const WazdanApp = {
  config: {
    recaptchaSiteKey: "6Ld3CEcaAAAAAMmyn2zy74zomWnyzQUZPIH0Zq1p",
    apiEndpoint: "https://wazdan.com/newsletter-hubspot-api",
  },

  state: {
    sliderInitialized: false,
    sliderCurrent: 0,
    sliderSlides: [],
    sliderLeft: null,
    sliderRight: null,
    isTeamExpanded: false,
    currentTeamFilter: "all",
  },

  elements: {
    filterButtons: [],
    teamCards: [],
    teamShowMoreBtn: null,
    backBtn: null,
    heroForm: null,
    heroCardBody: null,
    heroCardSuccess: null,
    heroSubmitBtn: null,
  },

  handlers: {
    onBackToFormClick: null,
    onFilterButtonClick: null,
    onShowMoreClick: null,
    onSliderLeftClick: null,
    onSliderRightClick: null,
    onResize: null,
    onFormSubmit: null,
  },

  debounce(fn, delay = 150) {
    let timeoutId;
    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => fn(...args), delay);
    };
  },

  init() {
    this.cacheElements();
    this.initBackToFormBtn();
    this.initTeamFilters();
    this.initTeamShowMore();
    this.initHeroForm();

    this.handlers.onResize = this.debounce(() => {
      this.handleSliderResize();
    }, 150);

    window.addEventListener("resize", this.handlers.onResize);
    this.handleSliderResize();
  },

  cacheElements() {
    this.elements.filterButtons = Array.from(
      document.querySelectorAll(".team__filter"),
    );
    this.elements.teamCards = Array.from(
      document.querySelectorAll(".team__card"),
    );
    this.elements.teamShowMoreBtn = document.getElementById("teamShowMoreBtn");
    this.elements.backBtn = document.getElementById("backToFormBtn");
    this.elements.heroForm = document.getElementById("hero-form");
    this.elements.heroCardBody = document.getElementById("heroCardBody");
    this.elements.heroCardSuccess = document.getElementById("heroCardSuccess");
    this.elements.heroSubmitBtn = document.getElementById("heroSubmitBtn");
  },

  initHeroForm() {
    if (
      !this.elements.heroForm ||
      !this.elements.heroCardBody ||
      !this.elements.heroCardSuccess
    ) {
      return;
    }

    this.handlers.onFormSubmit = async (event) => {
      event.preventDefault();

      const submitBtn = this.elements.heroSubmitBtn;
      const originalBtnText = submitBtn ? submitBtn.textContent : "";

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "Sending...";
      }

      try {
        let recaptchaToken = "";
        if (typeof grecaptcha !== "undefined") {
          recaptchaToken = await new Promise((resolve) => {
            grecaptcha.ready(async () => {
              const token = await grecaptcha.execute(
                this.config.recaptchaSiteKey,
                { action: "submit" },
              );
              resolve(token);
            });
          });
        }

        const formData = new FormData(this.elements.heroForm);
        const payload = {
          email: formData.get("email") || "",
          firstname: formData.get("firstname") || "",
          lastname: formData.get("lastname") || "",
          recaptchaToken: recaptchaToken,
          lead:'contact-lisbon-2026'
        };

        const response = await fetch(this.config.apiEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        this.elements.heroCardBody.classList.add("is-hidden");
        this.elements.heroCardSuccess.removeAttribute("hidden");
      } catch (error) {
        console.error("Form submission error:", error);
        alert("Wystąpił błąd podczas wysyłania formularza. Spróbuj ponownie.");

        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalBtnText;
        }
      }
    };

    this.elements.heroForm.addEventListener(
      "submit",
      this.handlers.onFormSubmit,
    );
  },

  initBackToFormBtn() {
    if (!this.elements.backBtn) return;
    this.handlers.onBackToFormClick = (event) => {
      event.preventDefault();
      const targetCard =
        document.getElementById("heroCard") ||
        document.getElementById("hero-form");
      if (targetCard) {
        targetCard.scrollIntoView({ behavior: "smooth", block: "center" });
        const firstInput = targetCard.querySelector("input");
        if (firstInput && !firstInput.closest(".is-hidden")) {
          firstInput.focus();
        }
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };
    this.elements.backBtn.addEventListener(
      "click",
      this.handlers.onBackToFormClick,
    );
  },

  initTeamFilters() {
    if (!this.elements.filterButtons.length || !this.elements.teamCards.length)
      return;

    this.handlers.onFilterButtonClick = (event) => {
      const button = event.currentTarget;
      this.elements.filterButtons.forEach((item) => {
        item.classList.remove("is-active");
        item.setAttribute("aria-pressed", "false");
      });
      button.classList.add("is-active");
      button.setAttribute("aria-pressed", "true");

      this.state.currentTeamFilter = button.dataset.filter || "all";
      this.state.isTeamExpanded = this.state.currentTeamFilter !== "all";
      this.renderTeamCards();
    };

    this.elements.filterButtons.forEach((button) => {
      button.addEventListener("click", this.handlers.onFilterButtonClick);
    });

    this.renderTeamCards();
  },

  initTeamShowMore() {
    if (!this.elements.teamShowMoreBtn) return;

    this.handlers.onShowMoreClick = () => {
      this.state.isTeamExpanded = true;
      this.renderTeamCards();
    };

    this.elements.teamShowMoreBtn.addEventListener(
      "click",
      this.handlers.onShowMoreClick,
    );
  },

  renderTeamCards() {
    const filter = this.state.currentTeamFilter;
    const isExpanded = this.state.isTeamExpanded;

    const matchingCards = this.elements.teamCards.filter((card) => {
      return filter === "all" || card.dataset.category === filter;
    });

    this.elements.teamCards.forEach((card) => {
      card.classList.add("is-hidden");
    });

    matchingCards.forEach((card, index) => {
      if (isExpanded || index < 3) {
        card.classList.remove("is-hidden");
      }
    });

    if (this.elements.teamShowMoreBtn) {
      if (matchingCards.length > 3 && !isExpanded) {
        this.elements.teamShowMoreBtn.classList.remove("is-hidden");
      } else {
        this.elements.teamShowMoreBtn.classList.add("is-hidden");
      }
    }
  },

  initMobileSlider() {
    if (this.state.sliderInitialized) return;

    this.state.sliderSlides = Array.from(
      document.querySelectorAll(".showcase__slider-slide"),
    );
    this.state.sliderLeft = document.querySelector(
      ".showcase__slider-arrow--prev",
    );
    this.state.sliderRight = document.querySelector(
      ".showcase__slider-arrow--next",
    );

    if (
      !this.state.sliderSlides.length ||
      !this.state.sliderLeft ||
      !this.state.sliderRight
    ) {
      return;
    }

    this.state.sliderCurrent = 0;
    this.handlers.onSliderLeftClick = this.handleSliderPrevClick.bind(this);
    this.handlers.onSliderRightClick = this.handleSliderNextClick.bind(this);

    this.state.sliderLeft.addEventListener(
      "click",
      this.handlers.onSliderLeftClick,
    );
    this.state.sliderRight.addEventListener(
      "click",
      this.handlers.onSliderRightClick,
    );

    this.updateSlides(this.state.sliderCurrent);
    this.state.sliderInitialized = true;
  },

  destroyMobileSlider() {
    if (!this.state.sliderInitialized) return;

    if (this.state.sliderLeft && this.handlers.onSliderLeftClick) {
      this.state.sliderLeft.removeEventListener(
        "click",
        this.handlers.onSliderLeftClick,
      );
    }
    if (this.state.sliderRight && this.handlers.onSliderRightClick) {
      this.state.sliderRight.removeEventListener(
        "click",
        this.handlers.onSliderRightClick,
      );
    }

    this.handlers.onSliderLeftClick = null;
    this.handlers.onSliderRightClick = null;
    this.state.sliderInitialized = false;
  },

  handleSliderPrevClick() {
    const length = this.state.sliderSlides.length;
    this.state.sliderCurrent = (this.state.sliderCurrent - 1 + length) % length;
    this.updateSlides(this.state.sliderCurrent);
  },

  handleSliderNextClick() {
    const length = this.state.sliderSlides.length;
    this.state.sliderCurrent = (this.state.sliderCurrent + 1) % length;
    this.updateSlides(this.state.sliderCurrent);
  },

  updateSlides(index) {
    const length = this.state.sliderSlides.length;
    this.state.sliderSlides.forEach((slide, slideIndex) => {
      slide.classList.remove("is-active", "is-prev", "is-next");
      if (slideIndex === index) {
        slide.classList.add("is-active");
        slide.setAttribute("aria-hidden", "false");
      } else {
        slide.setAttribute("aria-hidden", "true");
        if (slideIndex === (index - 1 + length) % length) {
          slide.classList.add("is-prev");
        } else if (slideIndex === (index + 1) % length) {
          slide.classList.add("is-next");
        }
      }
    });
  },

  handleSliderResize() {
    if (window.matchMedia("(max-width: 768px)").matches) {
      this.initMobileSlider();
    } else {
      this.destroyMobileSlider();
    }
  },
};

const startWazdanApp = () => {
  WazdanApp.init();
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", startWazdanApp);
} else {
  startWazdanApp();
}
